import { Button, Card, CardTitle, Toaster } from "@dune/ui";
import "@dune/ui/globals.css";
import { Mail02 } from "@untitled-ui/icons-react";
import { toast } from "sonner";
import { useCreateNewBrokerAccount } from "../../api/mutations/societies.mutations";
import { useOriasAndSirenContext } from "../../context/oriasAndSirenContext";

export default function SendEmail() {
	const { newBrokerAccountData } = useOriasAndSirenContext();
	const { mutate, isPending } = useCreateNewBrokerAccount();

	const onSubmit = () => {
		if (newBrokerAccountData) {
			mutate(newBrokerAccountData);
			toast("Vérifiez vos mails", {
				description: "Un mail vient d'être envoyé à votre adresse mail.",
			});
		} else
			toast("Une erreur est survenue", {
				description: "Erreur lors de l'envoie de mail.",
			});
	};

	return (
		<div className="bg-background-blue h-screen flex items-center justify-center">
			<div className="absolute top-0 left-0 p-6">
				<img src="/dune_white_logo.png" alt="Dune Logo" className="w-32" />
			</div>
			<div>
				<Card className="p-10 flex flex-col gap-7 max-w-[450px] overflow-auto text-center">
					<Mail02 className="text-background-blue mx-auto w-[2rem] h-[2rem]" />
					<CardTitle className="text-4xl">Vérifiez vos emails</CardTitle>
					<div className="flex flex-col items-start gap-3">
						<div>
							Un email vous a été envoyé à l'adresse suivante{" "}
							{newBrokerAccountData?.email}
						</div>
						<div>
							Cliquez sur le lien pour finaliser votre demande de partenariat
						</div>
					</div>
					<Button
						variant="outline"
						disabled={isPending}
						isLoading={isPending}
						size={"lg"}
						onClick={onSubmit}
					>
						Renvoyer le mail
					</Button>
				</Card>
			</div>
			<Toaster />
		</div>
	);
}
